import { styled } from "styled-components";
import Layout from "../components/Layout";
import AboutImage  from "../assets/images/about.jpg";

function About() {
  return (
    <Layout>
      <AboutWrapper className="layoutWrapper">
        <Hero />
        <p>Our team of Standard Chartered engineers ensure the bank is using standardised, stable, and secure technology services with our client needs in mind. Our focus is on delivering a world class client experience, building services that are compliant, resilient and secure by design, creating simplicity through self-services, APIs and transparency and achieving this with an empowered, diverse workforce adopting new ways of working.</p>
        <p>This blog creates a space for us to showcase our engineers’ thoughts, ideas, and innovations as we realise our transformation journey through building a strong engineering culture.</p>
      </AboutWrapper>
    </Layout>
  );
}
export default About;

const AboutWrapper = styled.section`
  p{
    margin-bottom: 20px;
    font-size: 20px;
    text-align: center;
  }
`;

export const Hero = styled.h3`
    height: 400px;
    background: url(${AboutImage}) 0 0 no-repeat;
    margin-bottom: 50px;
    @media (max-width: 790px) {
      height: 200px;
      background-size: cover;
    }
`;
